import HelpCentersContent from "./HelpCentersContent";

export default HelpCentersContent;
